import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const scaleIn = keyframes`
  from { opacity: 0; transform: scale(0.96) translateY(8px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.15s ease;
`;

export const ModalBox = styled.div`
  width: 480px;
  max-height: 560px;
  background-color: #fff;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  animation: ${scaleIn} 0.18s ease;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.02em;
`;

export const CloseButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background-color: #f5f5f5;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  transition: background-color 0.15s;

  &:hover { background-color: #ebebeb; }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 16px 24px 20px;
  gap: 12px;
`;

export const SearchWrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #bbb;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 44px;
  padding: 0 12px 0 38px;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  font-size: 14px;
  color: #111;
  background-color: #fafafa;
  transition: border-color 0.15s;
  box-sizing: border-box;

  &::placeholder { color: #bbb; }
  &:focus { outline: none; border-color: #1fbc70; background-color: #fff; }
`;

export const ResultList = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const StatusText = styled.p`
  text-align: center;
  font-size: 13px;
  color: #bbb;
  padding: 32px 0;
`;

export const ResultItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  transition: background-color 0.12s;

  &:hover { background-color: #fafff9; }
`;

export const ResultThumb = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  background-color: #f0f0f0;
`;

export const ResultThumbPlaceholder = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
`;

export const ResultInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultName = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultSub = styled.p`
  font-size: 12px;
  color: #aaa;
  margin-top: 2px;
`;

export const AddButton = styled.button<{ isDone?: boolean }>`
  flex-shrink: 0;
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: ${({ isDone }) => (isDone ? "default" : "pointer")};
  border: none;
  transition: background-color 0.15s;

  ${({ isDone }) =>
    isDone
      ? `
    background-color: #e8f8f0;
    color: #1fbc70;
  `
      : `
    background-color: #1fbc70;
    color: #fff;
    &:hover { background-color: #18a860; }
  `}

  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;
